<tgrid-layer-header [layer]="this" [additionIcons]="iconConfig()">

  <div ngProjectAs="filters">
    <form [formGroup]="filterGroup">
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Year</mat-label>
        <mat-select formControlName="year">
          <mat-option [value]="2020">2020</mat-option>
          <mat-option [value]="2026">2026</mat-option>
          <mat-option [value]="2035">2035</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Minimum headroom (MW)</mat-label>
        <input matInput type="number" formControlName="minCapacity">
        <mat-hint align="end">0 - 2,000MW</mat-hint>
      </mat-form-field>
    </form>
  </div>

  <div class="legend">

    <div class="legend-label">
      <div class="color-circle" [style.background-color]="'#FF0000'"></div>
      <span><100MW</span>
    </div>
    <div class="legend-label">
      <div class="color-circle" [style.background-color]="'#FF8000'"></div>
      <span>100MW - 500MW</span>
    </div>
    <div class="legend-label">
      <div class="color-circle" [style.background-color]="'#00FF00'"></div>
      <span>>500MW</span>
    </div>
    <div class="legend-label">
      <div class="color-circle" [style.background-color]="'#444444'"></div>
      <span>Not Covered</span>
    </div>

  </div>
</tgrid-layer-header>
